import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    completeFinishRaceEntrantsList: {
    data: []
  },
};

export const completeFinishRaceEntrantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_COMPLETE_FINISH_RACE_ENTRANTS:
      return {
        ...state,
        completeFinishRaceEntrantsList: action.payload,
      };
    default:
      return state;
  }
};
